/**
 * 外部URL定数
 * アプリケーション全体で使用する外部リンクのURLを一元管理
 */

/** 発注フォームURL */
export const ORDER_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScyb6YBLZ2DRlMB4Djlef3fFHoyJKnxiO6I4RnYvjRqCBXK5w/viewform";

/** マニュアル（Notion）URL */
export const MANUAL_URL =
  "https://trustart.notion.site/a11d52b037224591a30999b2a672e14b";

/** お問い合わせフォームURL */
export const CONTACT_US_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSc55YOK76TfgQyXEYUoXQS6eZIC25V2qwKdILOMxV87fBCdIQ/viewform";

/** 役所資料取得代行のマニュアル (Notion) */
export const REAL_ESTATE_DOCUMENT_FETCH_MANUAL_URL =
  "https://www.notion.so/trustart/26a14754f2df8060a7aafab0e0644dd5";
